import logoMin from '@static/vectors/footer/logo_min.svg'
import logoPRT from '@static/vectors/footer/logo_prt.svg'
import logoUE from '@static/vectors/footer/logo_ue.svg'
import logoKit from '@static/vectors/footer/logo_kit.svg'
import logoRedes from '@static/vectors/footer/logo_redes.svg'
import './SupportLogos.css'

export default function SupportLogos({ mini = false }: { mini?: boolean }) {
  return (
    <div className={`support-logos${mini ? ' mini' : ''}`}>
      <img className="support-logo" src={logoMin} alt="" />
      <img className="support-logo" src={logoUE} alt="" />
      <img className="support-logo" src={logoPRT} alt="" />
      <img className="support-logo" src={logoKit} alt="" />
      <img className="support-logo" src={logoRedes} alt="" />
    </div>
  )
}
